// extracted by mini-css-extract-plugin
module.exports = {"appliedFilter":"applied_filter-module__appliedFilter___3Ew6J","name":"applied_filter-module__name___3EnNI","value":"applied_filter-module__value___zKhDP"};